import './MHistory.css';

const MHistory = () => {
    return (
        <main>
            <h1>Монголын Бурханы шашны түүх</h1>
        </main>
    )
}
export default MHistory;